import axios from 'axios'

import { unique } from '@/helpers/api'
import type { PageNumberPagination, UUID } from '@/types'
import type { Budget, BudgetEntry, BudgetLight } from '@/types/budget'

import type { PageNumberPaginationParameters } from '.'

export const listBudgets = unique(
  async (params: PageNumberPaginationParameters): Promise<PageNumberPagination<BudgetLight>> =>
    (await axios.get('/budget/', { params })).data,
)

export const retrieveBudget = unique(
  async (budgetId: UUID): Promise<Budget> => (await axios.get(`/budget/${budgetId}/`)).data,
)

export interface BudgetEntriesListParameters extends PageNumberPaginationParameters {
  process_id?: UUID
}

export interface BudgetEntryPagination<T> extends PageNumberPagination<T> {
  budget_total: string
}

export const listBudgetEntries = unique(
  async (
    budgetId: UUID,
    params: BudgetEntriesListParameters,
  ): Promise<BudgetEntryPagination<BudgetEntry>> =>
    (await axios.get(`/budget/${budgetId}/entry/`, { params })).data,
)
